export const IconCalendar = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
			<path
				fill="#7F829C"
				d="M15,1 C17.209139,1 19,2.790861 19,5 L19,15 C19,17.209139 17.209139,19 15,19 L5,19 C2.790861,19 1,17.209139 1,15 L1,5 C1,2.790861 2.790861,1 5,1 L15,1 Z M15,3 L5,3 C3.8954305,3 3,3.8954305 3,5 L3,15 C3,16.1045695 3.8954305,17 5,17 L15,17 C16.1045695,17 17,16.1045695 17,15 L17,5 C17,3.8954305 16.1045695,3 15,3 Z M7,13 L7,15 L5,15 L5,13 L7,13 Z M11,13 L11,15 L9,15 L9,13 L11,13 Z M15,13 L15,15 L13,15 L13,13 L15,13 Z M7,10 L7,12 L5,12 L5,10 L7,10 Z M11,10 L11,12 L9,12 L9,10 L11,10 Z M15,10 L15,12 L13,12 L13,10 L15,10 Z M7,7 L7,9 L5,9 L5,7 L7,7 Z M11,7 L11,9 L9,9 L9,7 L11,7 Z M15,7 L15,9 L13,9 L13,7 L15,7 Z"
			/>
		</svg>
	);
};
